var QFind = require('./QFind').QFind;

export class QFindList extends QFind {
}
